import _ from 'lodash';

import MenuBarItem from '../menuBar/item';

import withDropDown from '../hocs/withDropDownAction/withDropDownOnHover';
import withCustomDropPanel from '../hocs/withCustomDropPanel';

export default _.flow(
  withDropDown,
  withCustomDropPanel(({ handlerKey }) => handlerKey),
)(MenuBarItem);
